module.exports = __webpack_public_path__ + "static/img/892.d7cf03f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/892.jpg
// module id = kVV5
// module chunks = 0